import React, { Component } from "react";
import ProgressiveImage from "react-progressive-image";
import styles from "./Images.module.scss";
import { ImageNav } from "./ImageNav";
import classNames from "classnames/bind";
import { widenResize, isWidenImage } from "helpers";

var cx = classNames.bind(styles);

export default class ProductImages extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.imagesRef = React.createRef();
  }

  componentDidMount() {
    this.updateDisplayAllImages();
    window.addEventListener("resize", this.handleImageNavResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleImageNavResize);
  }

  handleImageNavResize = () => {
    if (this.debounceResize) clearTimeout(this.debounceResize);
    this.debounceResize = setTimeout(() => {
        this.updateDisplayAllImages()
    }, 300);
  }

  updateDisplayAllImages = () => {
    const { setContainerState } = this.props;
    const displayAllImages = window.innerWidth <= 768;
    setContainerState("displayAllImages")(displayAllImages);
  }

  render() {
    const { activeImage, setContainerState, images, displayAllImages } = this.props;
    const isImage = isWidenImage(activeImage?.image);

    const updateActiveImage = hash => {
      const activeImage = images.find(image => hash === image.hash);
      setContainerState("activeImage")(activeImage);
      setContainerState("selectedGlassDesign")(null);
    };

    const Image = ({ className, alt_text, image: src }) => (
      <img className={className} alt={alt_text} src={src} />
    );

    const MainImage = () => {
     return (
        <ProgressiveImage
          src={activeImage}
          placeholder="https://dummyimage.com/540x1200/CCCCCC/555555.jpg"
        >
          {(src, loading) =>
            activeImage && isImage && (
              <Image
                className={cx("img")}
                {...activeImage}
                image={widenResize(activeImage.image, 750, 750)}
              />
            )
          }
        </ProgressiveImage>
      );
    }

    return (
      <div className={cx(["ProductImagesContainer"])} ref={this.containerRef}>
        <div className={cx(["ProductImages"])} ref={this.imagesRef}>
          <ImageNav
            key={images}
            displayAll={displayAllImages}
            images={images}
            activeImage={activeImage}
            onChange={(hash) => updateActiveImage(hash)}
          />
          <div className={cx("activeImageContainer")}>
            <MainImage />
          </div>
        </div>
      </div>
    );
  }
}
